import { useState, useEffect, useRef } from "react";
import React from "react";
import { useSelector } from "react-redux";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import SearchHeader from "../../Setup/Shared/SearchHeader";
import ModalHeader from "../../Setup/Shared/ModalHeader";
import isNull from "../../../utils/NullChecking";
import { Modal } from "react-bootstrap";
import { enumUtil } from "../../../utils/Enum";
import {
  ServerRequestPublic,
  ServerRequestProtected,
} from "../../../utils/ServerDataRequest";
import NotificationHandler from "../../../utils/NotificationHandler";
import Loader from "../../shared/Loader/Loader";
import DeleteConfirmatiom from "../../General/DeleteConfirmation";
import DatePicker from "../../General/DatePicker";
import { format, isBefore, startOfDay } from "date-fns";
import FormValidator from "../../../utils/FormValidator";
import downloadicon from "../../../assets/img/download.svg";
import Audit from "../../General/Audit";
import TextEditor from "../../../shared-components/TextEditor";
import { convertTimeToHMS } from "../../../utils/Constants";
import { saveAs } from "file-saver";
import { FindFirstChild } from "../../../utils/FindMenuOption";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import useHandleOpenNewBrowserTab from "../../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import SuperSearchMultipleServer from "../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer";
import { PDF, Textfile } from "../../shared/IconsComponent/icons";
import { use } from "react";
import Patient from "../../Patient/Patient";
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../actions/SidebarAction";
import { useDispatch } from "react-redux";
import IntakePreview from "../../Scheduler/IntakePreview/IntakePreview";
import useSidebarSubMainTab from "../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab";
import { GeneralDropDowns } from "../../../actions/GeneralPatientActions";
import ContentReceiver from "../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";

const AddNewTask = (props) => {
  const { IsOpen, IsClosed, onDeleteTask, view } = { ...props };

  let IsEditAllowed = view === 'AllTasks' || view === 'MyTasks' ? FindFirstChild("Home", "Task")?.IsAdd : FindFirstChild("Home", "System Generated Task")?.IsAdd;
  let IsDeleteAllowed = view === 'AllTasks' || view === 'MyTasks' ? FindFirstChild("Home", "Task")?.IsDeleted : FindFirstChild("Home", "System Generated Task")?.IsDeleted;
  const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
  const API_URL_Wasabi_Download = enumUtil.controller.Wasabi_Download;
  let dispatch = useDispatch();
  const openSidebarSubMainTab = useSidebarSubMainTab();
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  let isHomeCareCheck = DropDowns.IsHomeCare
  let Task_model = {
    Task: "",
    // Description: "",
    Files: "",
    DueDate: null,
    TaskStatus: "Open",
    TaskFor:
      props.PatientName ||
        props.ClaimName ||
        props.PaymentName ||
        props.CaregiverName ||
        props.Billingname === "ClaimSearch" ? "Claim" : "" ||
      "Patient",
    // Patient
    Priority: "",
    Assignee: null,
    PatientID: "",
    PatientIDs: "",
    VisitID: "",
    VisitIDs: "",
    PaymentID: "",
    PaymentIDs: "",
    OtherDetails: '',
    AppointmentDate: "",
    AppointmentStart: '',
    AppointmentType: '',
    EncounterDate: '',
    EncounterID: '',
    EncounterType: '',
    // CaregiverID:"",
    CaregiverIDs: "",
    UpdatedBy: "",
    UpdatedDate: "",
  };
  let Task_modeld = {
    Description: "",
  };

  let valModal = {};
  let ValidationModal = {
    Task: "",
    TaskFor: "",
    Assignee: "",
    DueDate: "",
    Priority: "",
    AdditionalIDs: "",
  };
  const TaskStatus = [
    { value: "Open", display: "Open" },
    { value: "In Progress", display: "In Progress" },
    { value: "In Review", display: "In Review" },
    { value: "Closed", display: "Closed" },
  ];

  const Priority = [
    { value: "Urgent", display: "Urgent" },
    { value: "High", display: "High" },
    { value: "Normal", display: "Normal" },
    { value: "Low", display: "Low" },
  ];

  const TaskData = [
    { value: "Patient", display: "Patient" },
    { value: "Claim", display: "Claim" },
    { value: "Payment", display: "Payment" },

  ];
  const [subTabID, setSubTabID] = useState();
  const [is, setIs] = useState(false);
  const API_URL = enumUtil.controller.Claim;
  const API_URL_General = enumUtil.controller.General;
  const [patientBody, setPatientBody] = useState({
    Search: "",
    SearchType: "Patient",
  });
  // const [visitBody, setVisitBody] = useState({
  //   TableName: "",
  //   SearchCriteria: "",
  // });
  const [visitBody, setVisitBody] = useState({
    Search: "",
    SearchType: "Claim",
  });
  // const [paymentBody, setPaymentBody] = useState({
  //   TableName: "",
  //   SearchCriteria: "",
  // });
  const [paymentBody, setPaymentBody] = useState({
    Search: "",
    SearchType: "Payment",
  });
  const [caregiverBody, setCaregiverBody] = useState({
    TableName: "",
    SearchParam: "",
  });
  let DropdownData = useSelector((state) => state.GeneralDropDownsReducer);
  const [mainTaskmanagementmodel, setmainTaskmanagementmodel] =
    useState(Task_model);
  const [TaskSaveupdatemodel, setTaskSaveupdatemodel] = useState({
    TaskFor:
      props.PatientName ||
      props.ClaimName ||
      props.PaymentName ||
      props.CaregiverName ||
      props.Billingname ||
      "Patient",
  });

  const [newTask, setnewTask] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activitypopup, setActivitypopup] = useState(false);
  const [Files, setFiles] = useState([]);
  const [taskID, SetTaskID] = useState();
  const [onTasksave, setonTasksave] = useState(false);
  const [del, setDel] = useState(false);
  const [isOpenAlert, setisOpenAlert] = useState(false);
  const [taskValidationModal, setTaskValidationModal] =
    useState(ValidationModal);
  const [isOpenAudit, setisOpenAudit] = useState(false);
  const [isReadOnly, setisReadOnly] = useState(true);
  const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);
  const [reloadSuperSearchClaim, setReloadSuperSearchClaim] = useState(false);
  const [reloadSuperSearchPayment, setReloadSuperSearchPayment] = useState(false);
  const [reloadSuperSearchCaregiver, setReloadSuperSearchCaregiver] = useState(false);
  const [reloadSuperSearchOther, setReloadSuperSearchOther] = useState(false);
  const [mainTaskmanagementmodeld, setmainTaskmanagementmodeld] =
    useState(Task_modeld);
  const [TaskSaveupdatemodeld, setTaskSaveupdatemodeld] = useState({});
  const API_URL_Wasabi = enumUtil.controller.Wasabi;
  const inputRef = useRef("");
  const inputRefComment = useRef("");
  let Note_Modal = {
    Comment: "",
    NoteReply: "",
    NoteFile: null,
  };
  const [commentID, setCommentID] = useState(0);
  const [PreviousComment, setPreviousComment] = useState("");

  const [commentData, setCommentData] = useState([]);
  const [parentID, setParentIID] = useState(null);
  const [mainNoteModal, setMainNoteModal] = useState(Note_Modal);
  const [noteSaveUpdateModal, setNoteSaveUpdateModal] = useState({});
  const [deleteComment, setDeleteComment] = useState(false);
  const [delCommentID, setDelCommentID] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [oepnReply, setOpenReply] = useState(false);
  const [oepn, setOpen] = useState(true);
  const [PatientValue, setPatientValue] = useState([]);
  const [CaregiverValue, setCaregiverValue] = useState([]);
  const [PaymentValue, setPaymentValue] = useState([]);
  const [VisitValue, setVisitValue] = useState([]);
  const [selectReply, setSelectReply] = useState([]);
  const [IsOpenIntakePreview, setIsOpenIntakePreview] = useState(false);
  const [EHRTemplateID, setEHRTemplateID] = useState(0);
  const [IntakeFormID, setIntakeFormID] = useState(null);
  const [IntakeStatus, setIntakeStatus] = useState('');
  const [PatientID, setPatientID] = useState(null);
  const [replyState, setReplyState] = useState({
    create: true,
    update: false,
  });

  useEffect(() => {
    if (!isNull(props.Task)) {
      SetTaskID(props.Task);
      setDel(true);
    } else {
      if (!onTasksave) {
        SetTaskID(0);
        setDel(false);
      } else {
        setDel(true);
      }
    }
  }, []);

  useEffect(() => {
    if (props.ClaimName === "Claim") {
      setTaskSaveupdatemodel({
        ...TaskSaveupdatemodel,
        VisitID: props?.selectedClaimId,
        AdditionalIDs: props?.selectedClaimId,
        TaskFor: "Claim",
      });
      setmainTaskmanagementmodel({
        ...mainTaskmanagementmodel,
        VisitID: props?.selectedClaimId,
        AdditionalIDs: props?.selectedClaimId,
        TaskFor: "Claim",
      })
      setVisitValue([{ value: parseInt(props?.selectedClaimId), display: props?.selectedClaimId, }]);
      setReloadSuperSearchClaim(!reloadSuperSearchClaim);
    }
    if (props.Billingname === "ClaimSearch" || props.Billingname === "AgencySearch") {

      let arrayofIDs = String(props.selectedClaimId)?.split(', ');

      const uniqueValues = [...new Set(arrayofIDs)];

      setTaskSaveupdatemodel({
        ...TaskSaveupdatemodel,
        AdditionalIDs: uniqueValues.join(", "),
        TaskFor: "Claim",
      });
      setmainTaskmanagementmodel({
        ...mainTaskmanagementmodel,
        AdditionalIDs: uniqueValues.join(", "),
        TaskFor: "Claim",
      });
      // setVisitValue(uniqueValues);
      let arrayofObjs = []
      arrayofObjs = uniqueValues?.map((id) => {
        return { value: id, display: id }
      })
      setVisitValue(arrayofObjs);
      setReloadSuperSearchClaim(!reloadSuperSearchClaim);
    }

    if (props.PatientName === "Patient") {
      setTaskSaveupdatemodel({
        ...TaskSaveupdatemodel,
        AdditionalIDs: props?.selectedPatientID?.ID,
        TaskFor: "Patient",
      });
      setmainTaskmanagementmodel({
        ...mainTaskmanagementmodel,
        AdditionalIDs: props?.selectedPatientID?.FullName,
        TaskFor: "Patient",
      });

      setPatientValue([{ value: props?.selectedPatientID?.ID, display: props?.selectedPatientID?.FullName }]);
      setReloadSuperSearchPatient(!reloadSuperSearchPatient);
    }

    if (props.PaymentName === "Payment") {

      setTaskSaveupdatemodel({
        ...TaskSaveupdatemodel,
        AdditionalIDs: props?.selectedPaymentId,
        TaskFor: "Payment",
        PaymentType: props?.type,
      });
      setmainTaskmanagementmodel({
        ...mainTaskmanagementmodel,
        AdditionalIDs: props?.selectedPaymentName,
        TaskFor: "Payment",
      });
      setPaymentValue([{ value: parseInt(props?.selectedPaymentId), display: props?.selectedPaymentName }]);
      setReloadSuperSearchPayment(!reloadSuperSearchPayment);
    }
    if (props.PaymentName === "Caregiver") {
      setTaskSaveupdatemodel({
        ...TaskSaveupdatemodel,
        AdditionalIDs: props?.selectedPaymentId,
        TaskFor: "Caregiver",
      });
      setmainTaskmanagementmodel({
        ...mainTaskmanagementmodel,
        AdditionalIDs: props?.selectedPaymentName,
        TaskFor: "Caregiver",
      });
      setCaregiverValue([{ value: parseInt(props?.selectedPaymentId), display: props?.selectedPaymentName }])
      setReloadSuperSearchCaregiver(!reloadSuperSearchCaregiver);
    }
    setIs(true);
    if (!isNull(taskID) && taskID !== "0") {
      setIsLoading(true);
      ServerRequestProtected(API_URL_General + "/FindTaskAttachments", "post", {
        ID: taskID,
        TableName: enumUtil.enumAPITableName.TaskAttachments,
      })
        .then((response) => {
          // setIsLoading(false)
          setIs(true);
          setSubTabID(
            response.Task[0].PatientID ||
            response.Task[0].PaymentID ||
            response.Task[0].VisitID ||
            response.Task[0].CaregiverID
          );
          response.Task[0].DueDate =
            response.Task[0].DueDate === "" ? null : response.Task[0].DueDate;
          response.Task[0].Assignee = response.Task[0].AssigneeName;
          // response.Task[0].PatientID = response.Task[0].PatientName;
          // response.Task[0].PaymentID = response?.Task[0]?.TRNCheckNumber;

          // let additionalIDs = String(response?.Task[0]?.AdditionalIDs).split(', ');
          // let array = [];
          // additionalIDs?.map((id) => {

          //   let obj = {
          //     value: parseInt(id), display: id
          //   }

          //   array.push(obj);
          // })
          if (response?.Task[0]?.TaskFor === 'Patient') {

            setPatientValue(response?.Task[0]?.AdditionalIDs)
            setReloadSuperSearchPatient(!reloadSuperSearchPatient)

          }
          if (response?.Task[0]?.TaskFor === 'Claim') {

            setVisitValue(response?.Task[0]?.AdditionalIDs)
            setReloadSuperSearchClaim(!reloadSuperSearchClaim)

          }
          if (response?.Task[0]?.TaskFor === 'Payment') {

            setPaymentValue(response?.Task[0]?.AdditionalIDs)
            setReloadSuperSearchPayment(!reloadSuperSearchPayment)

          }
          response?.Task[0]?.["Task Attachment"]?.map((item, index) => {
            setFiles((prevFiles) => [...prevFiles, { item }]);
            // setFiles(prevFiles => [...prevFiles, { name: item.FileName }]);

            // setFiles(prevFiles => [...prevFiles, { name: item.FileName }]);
          });
          let additionalIDs = []
          additionalIDs = response?.Task[0]?.AdditionalIDs?.map(item => item?.value) || [];
          let additionalIdString = additionalIDs.join(', ')

          setTaskSaveupdatemodel({ ...TaskSaveupdatemodel, TaskFor: response?.Task[0]?.TaskFor, AdditionalIDs: additionalIdString })
          setmainTaskmanagementmodel(response?.Task[0]);
          setmainTaskmanagementmodeld(response?.Task[0]);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
        });
    }
  }, [taskID]);



  const getFileExtension = (file) => {
    const validExtensions = ["jpg", "jpeg", "png", "gif", "pdf", "doc", "docx", "txt", "xls", "xlsx", "csv", "mp4", "mp3"]; // Add more as needed
    if (file?.name?.includes(".")) {
      const potentialExt = String(file.name).split(".").pop();
      // Check if the extracted part is in the list of valid extensions
      if (validExtensions.includes(potentialExt.toLowerCase())) {
        return potentialExt;
      }
    }
    return ""; // Return empty string if no valid extension is found
  };

  const getFlieTypeIcon = (extension) => {

    switch (String(extension).toLowerCase()) {

      case 'jpg':
      case 'jpeg':
      case 'png':
        return <i className='icon-image fs-22'></i>

      case 'pdf':
        return <PDF />

      case 'doc':
      case 'docx':
        return <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>

      case 'xls':
      case 'xlsx':
        return <i className='icon-excel fs-21 text-success'></i>

      case 'txt':
        return <Textfile />

      default:
        return <i className='icon-image fs-22'></i>;

    }

  }

  const handleFileChange = (e) => {

    const newFiles = e.target.files;
    const allFiles = [...Files, ...newFiles];

    setFiles(allFiles);
    for (let i = 0; i < allFiles.length; i++) {
      const file = allFiles[i];
    }
  };
  const [chatFile, setChatFile] = useState([])

  const handleFileChangeChat = (event) => {
    let { name, files } = event.target;

    setChatFile({ ...chatFile, [name]: Array.from(files) });

    const file = files[0];
    if (file) {

      const extension = getFileExtension(file);

      const reader = new FileReader();
      reader.onload = (event) => {

        setNoteSaveUpdateModal({ ...noteSaveUpdateModal, NoteFile: event.target.result.split("base64,")[1], FileExtension: extension, size: file?.size, FileName: file?.name })
      };
      reader.readAsDataURL(file);
    };
  };
  // const handleFileChangeChat = (e) => {
  //   const newFiles = e.target.files;
  //   const allFiles = [...chatFile, ...newFiles];
  //   setChatFile(allFiles);
  //   for (let i = 0; i < allFiles.length; i++) {
  //     const file = allFiles[i];
  //   }
  // };
  const removeFile = (indexToRemove) => {
    const updatedFiles = Files.filter((file, index) => index !== indexToRemove);

    if (updatedFiles?.length === 0) {
      if (inputRef.current) {
        inputRef.current.value = "";
      }

    }
    setFiles(updatedFiles);
  };
  const removeFilechat = (indexToRemove) => {

    const updatedFiles = chatFile?.Files?.filter((file, index) => index !== indexToRemove);

    setNoteSaveUpdateModal({ ...noteSaveUpdateModal, NoteFile: "", FileExtension: "", size: "" })
    if (updatedFiles?.length === 0) {
      if (inputRefComment.current) {
        inputRefComment.current.value = "";
      }
    }
    setChatFile(updatedFiles);

  };
  // const handleRemove = (index) => {
  //   const updatedFiles = [...noteSaveUpdateModal['NoteFile']];
  //   updatedFiles.splice(index, 1);
  //   setChatFile({ ...chatFile, ['NoteFile']: updatedFiles });
  //   // setInputKey(Date.now());
  //   setNoteSaveUpdateModal({ ...noteSaveUpdateModal, NoteFile: '' })
  // }
  const handleOnChange = (e) => {

    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    let saveModal = { ...TaskSaveupdatemodel };
    modal[name] = value;

    setmainTaskmanagementmodel(modal);
    for (var property in Task_model) {
      if (name === property) {
        saveModal[name] = value;
      }
    }
    setTaskSaveupdatemodel(saveModal);

  };

  const handleOnChanged = (e) => {
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodeld };
    let saveModal = { ...TaskSaveupdatemodeld };
    modal[name] = value;
    setmainTaskmanagementmodeld(modal);
    for (var property in Task_modeld) {
      if (name === property) {
        saveModal[name] = value;
      }
    }
    setTaskSaveupdatemodeld(saveModal);
  };
  const handleSuperlist = (e) => {
    setIs(false);
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    modal[name] = value;
    setmainTaskmanagementmodel(modal);
  };
  const handleSelectedData = (selectedData, name, type) => {
    console.log(selectedData, name, type);

    let modal = { ...mainTaskmanagementmodel };
    if (type === "client" && !isNull(selectedData)) {
      if (name === "TaskStatus") {
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value;
      } else if (name === "Priority") {
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value;
      } else if (name === "TaskFor") {
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value;

        if (selectedData.display === "Patient") {

          setReloadSuperSearchPatient(!reloadSuperSearchPatient);
        }
        else if (selectedData.display === "Payment") {
          setReloadSuperSearchPayment(!reloadSuperSearchPayment);
        }
        else if (selectedData.display === "Claim") {
          setReloadSuperSearchClaim(!reloadSuperSearchClaim);
        }
        else if (selectedData.display === "Patient") {
          setReloadSuperSearchCaregiver(!reloadSuperSearchCaregiver);
        }
        else {
          setReloadSuperSearchOther(!reloadSuperSearchCaregiver);
        }


      } else if (name === "Assignee") {
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value;
      }
    } else if (type === "server" && !isNull(selectedData)) {
      if (name === "POSCode") {
        // practiceSaveUpdateModal[name] = selectedData.ID
        // setSearchValue(selectedData.ID)
      }
    } else {
      modal[name] = "";
      TaskSaveupdatemodel[name] = "";
    }
    setmainTaskmanagementmodel(modal);
    setTaskValidationModal({ ...taskValidationModal, AdditionalIDs: "" });
    return selectedData;
  };
  const handlePatientChange = (e) => {
    setIs(false);
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    modal[name] = value;
    mainTaskmanagementmodel.PatientID = value;
    setPatientValue(value);
    setmainTaskmanagementmodel(modal);
    setPatientBody({
      TableName: enumUtil.enumAPITableName.Task,
      SearchCriteria: {
        Search: value,
        SearchType: "Patient",
      },
    });
  };
  const TaskValidation = async () => {
    let ValidationModal = {
      taskCodeVal: FormValidator(
        mainTaskmanagementmodel.Task,
        enumUtil.enumValidationType.Required,
        "Task Title"
      ),
      taskTaskForVal: FormValidator(
        mainTaskmanagementmodel.TaskFor,
        enumUtil.enumValidationType.Required,
        "Category"
      ),
      taskAssigneeVal: FormValidator(
        mainTaskmanagementmodel.Assignee,
        enumUtil.enumValidationType.Required,
        "Assinee Name "
      ),
      DueDate: FormValidator(
        mainTaskmanagementmodel.DueDate,
        enumUtil.enumValidationType.Required,
        "Due Date"
      ),
      Priority: FormValidator(
        mainTaskmanagementmodel.Priority,
        enumUtil.enumValidationType.Required,
        "Priority"
      ),
      AdditionalIDs: mainTaskmanagementmodel?.TaskFor === "Other" ? FormValidator(
        mainTaskmanagementmodel?.OtherDetails,
        enumUtil.enumValidationType.Required,
        `Other Detail`
      )
        : FormValidator(
          TaskSaveupdatemodel?.AdditionalIDs,
          enumUtil.enumValidationType.Required,
          `${TaskSaveupdatemodel?.TaskFor} ID`
        ),
    };
    await setTaskValidationModal(ValidationModal);
    valModal = ValidationModal;
  };
  const handleVisitChange = (e) => {
    setIs(false);
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    modal[name] = value;
    setmainTaskmanagementmodel(modal);
    setVisitBody({
      TableName: enumUtil.enumAPITableName.Task,
      SearchCriteria: {
        Search: value,
        SearchType: "Claim",
      },
    });
  };
  const handleSelectedClaimInfoData = (selectedData, name, type) => {
    let modal = { ...mainTaskmanagementmodel };
    if (type === "client" && !isNull(selectedData)) {
    } else if (type === "server" && !isNull(selectedData)) {
      if (name === "PatientID") {
        setIs(true);
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value + "";
        setPatientValue(selectedData.display);
      }
      if (name === "PaymentID") {
        setIs(true);
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value + "";
        TaskSaveupdatemodel.PaymentType = selectedData.PaymentType;
        setPaymentValue(selectedData.display);
      }
      if (name === "CaregiverID") {
        setIs(true);
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value + "";
        setCaregiverValue(selectedData.display);
      }
      if (name === "VisitID") {

        setIs(true);
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value + "";
        TaskSaveupdatemodel["CliamType"] = selectedData.ClaimType + "";

        setVisitValue(selectedData.display);
      }
      if (name === "Assignee") {
        setIs(true);
        modal[name] = selectedData.display;
        TaskSaveupdatemodel[name] = selectedData.value + "";
      }
    } else {
      modal[name] = "";
      TaskSaveupdatemodel[name] = "";
      setPatientValue("");
      setCaregiverValue("");
      setPaymentValue("");
      setVisitValue("");
    }
    setmainTaskmanagementmodel(modal);
    return selectedData;
  };
  const onsubmitSaveDocument = async () => {
    await TaskValidation();
    let validation = FormValidator(
      [valModal],
      enumUtil.enumValidationType.NullCheck
    );
    let AdditionalIdCheck = !isNull(TaskSaveupdatemodel?.TaskFor) ? FormValidator(
      TaskSaveupdatemodel?.AdditionalIDs,
      enumUtil.enumValidationType.Required,
    ) : ""
    if (validation) {
      NotificationHandler("Fill Required Fields", enumUtil.enumtoaster.error);
      return;
    } else {
      setIsLoading(true);
      let imageFiles = Files;
      const formdata = new FormData();
      formdata.append("TableName", enumUtil.enumAPITableName.Task);
      let data = {
        ...TaskSaveupdatemodel,
        ...(isNull(taskID) ? { TaskStatus: mainTaskmanagementmodel.TaskStatus } : {}), //// commented due to hassam said so, every time notified that status updated. 
        Task: mainTaskmanagementmodel.Task,
        ...TaskSaveupdatemodeld,
      };
      formdata.append("ID", taskID > 0 ? taskID : 0);
      for (var key in data) {
        formdata.append(`data[${key}]`, data[key]);
      }

      if (imageFiles != undefined || imageFiles != null) {
        if (imageFiles.length > 0) {
          for (let i = 0; i < imageFiles.length; i++) {

            formdata.append("Files", imageFiles[i]);
          }
        } else {
          formdata.append("Files", null); // Append null if there are no files
        }
      }

      ServerRequestPublic(
        API_URL_General + "/SaveTask",
        "post",
        formdata,
        "Upload"
      )
        .then((response) => {
          setIsLoading(false);
          NotificationHandler(
            "Record Saved Successfully!",
            enumUtil.enumtoaster.success
          );
          setonTasksave(true);
          onDeleteTask();
        })
        .catch((error) => {
          setIsLoading(false);

          NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
        });
    }
  };
  const handlePaymentChange = (e) => {
    setIs(false);
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    modal[name] = value;
    mainTaskmanagementmodel.PaymentID = value;
    setmainTaskmanagementmodel(modal);
    setPaymentBody({
      TableName: enumUtil.enumAPITableName.Task,
      SearchCriteria: {
        Search: value,
        SearchType: "Payment",
      },
    });
  };
  const handleCaregiverChange = (e) => {
    setIs(false);
    let { name, value } = e.target;
    let modal = { ...mainTaskmanagementmodel };
    modal[name] = value;
    mainTaskmanagementmodel.PaymentID = value;
    setmainTaskmanagementmodel(modal);
    setCaregiverBody({
      TableName: enumUtil.enumAPITableName.Task,
      SearchCriteria: {
        Search: value,
        SearchType: "Caregiver",
      },
    });
  };
  const handleDeleteModal = () => {
    setisOpenAlert(true);
  };
  const onCloseDelete = () => {
    setisOpenAlert(false);
  };

  const onCloseDeleteComment = () => {

    let filteredReplies = selectReply.filter((item) => {
      return delCommentID !== item?.TaskCommentsID
    })
    setSelectReply(filteredReplies);
    setDeleteComment(false);
  };
  let DeletePopup = "";
  if (del) {
    DeletePopup = (
      <button
        className={
          IsDeleteAllowed
            ? "btn-icon-transparent"
            : "btn-icon-transparent delete-btn-disabled"
        }
        onClick={handleDeleteModal}
      >
        <span className="icon">
          <i className="icon-delete"></i>
        </span>
        <span className="title">Delete</span>
      </button>
    );
  }
  let DeleteConfirmation = "";
  if (isOpenAlert) {
    DeleteConfirmation = (
      <DeleteConfirmatiom
        isOpenAlert={isOpenAlert}
        onCloseDelete={onCloseDelete}
        API_URL={API_URL_General}
        TableName={enumUtil.enumAPITableName.Task}
        ID={taskID}
        onClose={onDeleteTask}
      />
    );
  }

  const setTaskName = () => {
    if (
      mainTaskmanagementmodel.Task != null &&
      mainTaskmanagementmodel.Task != ""
    ) {
      return <p className="heading validation_message text-nowrap">{mainTaskmanagementmodel.Task}</p>;
    } else {
      return <p className="heading w-100 text-center">Create new task</p>;
    }
    // return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>Create new task   </p>;
  };

  const handleReplyState = ({ create, update }) => {
    setReplyState({
      create: create,
      update: update,
    });
  };
  // const handleNoteChange = (e) => {
  //     let { name, value } = e.target;
  //         const mentionTriggerIndex = value.lastIndexOf('@');
  //         if (mentionTriggerIndex !== -1) {
  //             const query = value.substring(mentionTriggerIndex + 1);
  //             setMentionList(DropdownData.Users.filter(user => user.name.toLowerCase().includes(query.toLowerCase())));
  //             setShowMentions(true);
  //         } else {
  //             setShowMentions(false);
  //         }

  //     let modal = { ...mainNoteModal };
  //     let saveModal = { ...noteSaveUpdateModal }
  //     modal[name] = value
  //     setMainNoteModal(modal)
  //     for (var property in modal) {
  //         if (name === property) {
  //             saveModal[name] = value
  //         }
  //     }
  //     setNoteSaveUpdateModal(saveModal)
  // }
  const handleNoteChange = (e) => {
    const { name, value } = e.target;

    const mentionTriggerIndex = value.lastIndexOf("@");
    if (mentionTriggerIndex !== -1) {
      const query = value.substring(mentionTriggerIndex + 1);
      setMentionList(
        DropdownData.User.filter((user) =>
          user.display.toLowerCase().includes(query.toLowerCase())
        )
      );
      setShowMentions(true);
    } else {
      setShowMentions(false);
    }

    let modal = { ...mainNoteModal };
    let saveModal = { ...noteSaveUpdateModal };
    modal[name] = value;
    // setComment(value);  // Update comment state
    setMainNoteModal(modal);
    for (var property in modal) {
      if (name === property) {
        saveModal[name] = value;
      }
    }
    setNoteSaveUpdateModal(saveModal);
  };
  const LoadDataComment = () => {
    setCommentData([]);
    setIsLoading(true);
    ServerRequestProtected(
      API_URL_General + "/FindByMultipleCriteria",
      "post",
      {
        ID: taskID,
        TABLENAME: enumUtil.enumAPITableName.TASKCOMMENTS,
        PERPAGE: "10",
        PAGENO: "1",
      }
    )
      .then((response) => {
        setIsLoading(false);
        setCommentData(response.Rows);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const handleActivePopup = () => {
    setActivitypopup(true);
    LoadDataComment();
  };
  const handleReply = (id, value) => {
    selectReply.push(value);
    setParentIID(id);
    setOpenReply(true);
    setOpen(false);
  };
  useEffect(() => {

    if (props.OpenCommentbyDefault) {
      handleActivePopup()
    }
  }, [activitypopup])

  const [crossIcon, setCrossIcon] = useState(false);

  const handleUpdateCommentreply = (ID, Comment, record) => {
    setCrossIcon(true);
    if (ID != commentID) {

      if (!isNull(record?.BucketPath)) {

        setChatFile({
          Files: [{
            name: record?.FileName,
            size: record?.Size,
          }]
        })

      }

      setMainNoteModal({ ...Note_Modal, Comment: Comment, });
      setNoteSaveUpdateModal({ ...Note_Modal, Comment: Comment, });
    }

    setCommentID(ID);
    setPreviousComment(Comment);
    handleReplyState({ update: true });
  };

  useEffect(() => {
    if (!isNull(props.Task)) {
      LoadDataComment();
    }
  }, [refresh]);

  const handleBack = () => {
    setOpenReply(false);
    setOpen(true);
    setSelectReply([]);
    setParentIID(null);
  };

  const handleSetDefault = () => {
    setRefresh((prev) => !prev);
    setCommentID(0);
    setPreviousComment("");
    setMainNoteModal(Note_Modal);
    setNoteSaveUpdateModal(Note_Modal);
    setChatFile([]);

    if (inputRefComment.current) {
      inputRefComment.current.value = "";
    }

  };

  const handleSaveNote = async () => {
    // NoteReply !== "NoteReply" ? await NoteValidation() : await ReplyNoteValidation();
    // let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    // if (validation) {
    //     NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
    //     return
    // } else
    {
      let modalComment = {
        TableName: enumUtil.enumAPITableName.TASKCOMMENTS,
        ID: commentID + "",
        data: {
          TaskID: taskID,
          Comment: noteSaveUpdateModal.Comment,
          size: noteSaveUpdateModal.size + "",
          NoteFile: noteSaveUpdateModal.NoteFile,
          FileName: noteSaveUpdateModal?.FileName,
          FileExtension: noteSaveUpdateModal.FileExtension,
          MentionedUsers: mentionedUsers.join(', '),

          // FileName: chatFile?.File[0]?.name,
        },
      };
      let modalReplyComment = {
        TableName: enumUtil.enumAPITableName.TASKCOMMENTS,
        ID: "0",
        data: {
          TaskID: taskID,
          Comment: noteSaveUpdateModal.Comment,
          ParentID: parentID,
          size: noteSaveUpdateModal.size + "",
          NoteFile: noteSaveUpdateModal.NoteFile,
          FileName: noteSaveUpdateModal?.FileName,
          FileExtension: noteSaveUpdateModal.FileExtension,
          MentionedUsers: mentionedUsers.join(', '),

        },
      };

      let saveModal;

      // if (parentID === null) {

      //     saveModal = modalComment
      // } else {
      //     saveModal = modalReplyComment
      // }
      saveModal = replyState.update ? modalComment : modalReplyComment;

      setIsLoading(true);
      ServerRequestProtected(
        API_URL_General + "/SaveTaskComments",
        "post",
        saveModal
      )
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false);
            handleReplyState({ create: true });
            setCrossIcon(false)
            // NotificationHandler(
            //   "Record Saved Successfully!",
            //   enumUtil.enumtoaster.success
            // );
            handleSetDefault();
            // LoadDataComment();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        });
    }
  };

  const handleDelete = (id) => {
    setDelCommentID(id);
    setDeleteComment(true);
  };

  let DeleteConfirmations = "";
  if (deleteComment) {
    DeleteConfirmations = (
      <DeleteConfirmatiom
        isOpenAlert={deleteComment}
        onCloseDelete={onCloseDeleteComment}
        API_URL={API_URL}
        TableName={enumUtil.enumAPITableName.TASKCOMMENTS}
        ID={delCommentID}
        onClose={handleSetDefault}
      />
    );
  }

  const handleKey = (e, NoteReply, ParentID) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      NoteReply === "NoteReply"
        ? handleSaveNote(NoteReply, ParentID)
        : handleSaveNote();
    } else if (e.key === "Enter" && e.shiftKey) {
      handleNoteChange(e);
    } else if (e.key === "@") {
      setShowMentions(true);
    }
  };

  const handleNotes = (e) => {
    if (isNull(taskID)) {
      return
    }

    if (PreviousComment !== mainNoteModal?.Comment) {
      handleSaveNote(e)
    }
  }

  let nameFf, nameLl;
  const handleNameSplit = (Name) => {
    let name = !isNull(Name) ? Name?.split(" ") : ["", ""];
    let nameF = !isNull(name[0]) ? name[0] : "";
    let nameL = !isNull(name[1]) ? name[1] : "";
    nameFf = nameF[0];
    nameLl = nameL[0];
    return nameFf, nameLl;
  };

  const handleCalendarChange = (date, type) => {
    var FormatedDate = date
    let modal = { ...mainTaskmanagementmodel };
    let saveModal = { ...TaskSaveupdatemodel };
    modal[type] = FormatedDate;
    setmainTaskmanagementmodel(modal);
    for (var property in Task_model) {
      if (type === property) {
        saveModal[type] = FormatedDate;
      }
    }
    setTaskSaveupdatemodel(saveModal);
  };

  const handleAuditModal = () => {
    setisOpenAudit(true);
  };

  const onCloseAudit = () => {
    setisOpenAudit(false);
  };

  let AuditPopup = "";
  if (isOpenAudit) {
    AuditPopup = (
      <Audit
        isOpenAudit={isOpenAudit}
        onCloseAudit={onCloseAudit}
        ParentID={taskID + ""}
        TableName={enumUtil.enumAPITableName.Task}
      />
    );
  }

  const DownloadFile = (path, filename) => {
    setIsLoading(true);
    ServerRequestPublic(
      API_URL_Wasabi + "/DownloadFile",
      "post",
      {
        BucketPath: path,
      },
      "Download"
    )
      .then((response) => {
        setIsLoading(false);
        // setImageMenu(false)
        let blob = new Blob([response]);
        saveAs(blob, filename);
      })
      .catch((error) => {
        setIsLoading(false);
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      });
  };

  const cleartext = (type) => {
    setCrossIcon(false);
    setMainNoteModal({ ...mainNoteModal, Comment: "" });
    handleReplyState({ update: false });
    setCommentID(0);
  };

  const users = [
    { id: "1", name: "John Doe" },
    { id: "2", name: "Jane Smith" },
    { id: "3", name: "Alice Johnson" },
    { id: "4", name: "Bob Brown" },
  ];

  const [mentionList, setMentionList] = useState([]);
  const [showMentions, setShowMentions] = useState(false);
  const textareaRef = useRef(null);
  const [comment, setComment] = useState("");

  //////////////////// Open Intake Preview /////////////////
  const handleIntakePreview = (ID, FormID, PatientID, FormStatus) => {
    if (!isNull(ID)) {
      console.log("IntakePreview Patient Id", PatientID)
      setEHRTemplateID(ID);
      setIntakeFormID(FormID);
      setPatientID(PatientID);
      setIntakeStatus(FormStatus);
      setIsOpenIntakePreview(true);

    }

  }
  const onClose = () => {
    setIsOpenIntakePreview(false);
  }
  const onCloseSave = () => {
    setIsOpenIntakePreview(false);
    // LoadData(searchParam)
  }

  let IntakePreviewPopup = ""
  if (IsOpenIntakePreview) {
    IntakePreviewPopup = <IntakePreview isOpenPopup={IsOpenIntakePreview} onClose={onClose} onCloseSave={onCloseSave} ID={EHRTemplateID} intakeFormID={IntakeFormID} PatientID={PatientID} FormStatus={IntakeStatus} />
  }
  //////////////////// Open UnSigned Encounter /////////////////
  let state = useSelector(state => state.SidebarList)
  const handleActive_SubTab = (key, name, component, right) => {
    let arr = state
    let dynamicTabs = [...arr]
    const newTabObject = {
      key: key,
      name: name,
      component: component,
      right: right,
      time: new Date(),
    }
    const isTabExist = dynamicTabs.filter((tab) => {
      return tab.name === name
    })
    if (!(isTabExist && isTabExist.length > 0)) {
      dynamicTabs = [...dynamicTabs, newTabObject]
      dispatch(MainTabContentTabList(dynamicTabs));
    }
    dispatch(MainTabContentActiveTab(key))
    // setOpenTab && setOpenTab('')
  }
  const handleOpenEncounter = (encounter) => {
    if (!isNull(encounter?.EncounterID)) {
      IsClosed()
      handleActive_SubTab(2, 'Patient', <Patient />, true)
      dispatch({
        type: 'OPEN_PATIENT_WITH_ENCOUNTER_TAB',
        payload: {
          patientTab: {
            active: true,
            key: 2,
            name: "Patient",
            data: { id: encounter.PatientID, name: encounter.PatientName, type: "Encounter", },
            // other patient tab props
          },
          encounterTab: {
            active: true,
            key: 2,
            name: "Encounter",
            data: { id: encounter.EncounterID, name: encounter.EncounterDate, time: new Date(), type: encounter.NoteType, },
            // other encounter tab props
          }
        }
      });
      dispatch(GeneralDropDowns({
        ...DropdownData, DisCardActiveIds: {
          ...DropdownData?.DisCardActiveIds,
          Patient: [...DropdownData?.DisCardActiveIds.Patient, {
            isDemographicsOpened: false,
            isDemographicsUpdated: false,
            isInsuranceOpened: false,
            isInsuranceUpdated: false,
            PatientID: encounter.PatientID,
          }]
        }
      }))
    }


  }

  useEffect(() => {
    if (showMentions) {
      const handleClickOutside = (event) => {
        if (
          textareaRef.current &&
          !textareaRef.current.contains(event.target)
        ) {
          setShowMentions(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showMentions]);

  // const handleCommentChange = (e) => {
  //     const value = e.target.value;
  //     setComment(value);

  //     const mentionTriggerIndex = value.lastIndexOf('@');
  //     if (mentionTriggerIndex !== -1) {
  //         const query = value.substring(mentionTriggerIndex + 1);
  //         setMentionList(users.filter(user => user.name.toLowerCase().includes(query.toLowerCase())));
  //         setShowMentions(true);
  //     } else {
  //         setShowMentions(false);
  //     }
  // };

  // const handleKeyDown = (e) => {
  //     if (e.key === '@') {
  //         setShowMentions(true); 
  //     }
  // };

  function timeSince(dateString) {

    const enteredDate = new Date(dateString); // Parse the date string

    if (isNaN(enteredDate.getTime())) {
      return ""
    }

    const now = new Date(); // Current date and time
    const diffInMilliseconds = now - enteredDate; // Difference in milliseconds

    // Convert the difference to meaningful units
    const seconds = Math.floor(diffInMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    // Determine the most appropriate unit to display
    if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    }
  }

  const handleDownloadFile = (FilePath, item) => {

    setIsLoading(true)
    ServerRequestPublic(API_URL_Wasabi_Download, 'post', {
      "BucketPath": FilePath
    }, "Download")
      .then((response) => {
        setIsLoading(false)
        let blob = new Blob([response]);
        saveAs(blob, FilePath.split("/").pop());
      }).catch((error) => {
        setIsLoading(false)
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      })
  }

  const [mentionedUsers, setMentionedUsers] = useState([])
  const handleMentionClick = (user) => {
    const mentionTriggerIndex = mainNoteModal?.Comment.lastIndexOf("@");
    const newComment =
      mainNoteModal?.Comment.substring(0, mentionTriggerIndex) +
      "@" +
      user.display +
      " ";
    setMentionedUsers(pre => [...pre, user.value])
    // setComment(newComment);
    setMainNoteModal({ ...mainNoteModal, Comment: newComment });
    setShowMentions(false);
  };

  const [selectedFiles, setSelectedFiles] = useState();

  const handleNotesFileChange = (event) => {
    let { name, files } = event.target;
    setSelectedFiles({ ...selectedFiles, [name]: Array.from(files) });
    const file = files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        // setNoteSaveUpdateModal({ ...noteSaveUpdateModal, [`${name}base64`]: event.target.result.split("base64,")[1] })
        setNoteSaveUpdateModal({
          ...noteSaveUpdateModal,
          NoteFile: event.target.result.split("base64,")[1],
        });
      };
      reader.readAsDataURL(file);
    }
  };
  const [pdfFile, setPdfFile] = useState(null);
  const [txtFile, setTxtFile] = useState(null);
  const [imgFile, setImgFile] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const ViewFile = (data) => {
    setPdfFile(null);
    setTxtFile(null);
    setImgFile(null);
    setIsLoading(true);
    ServerRequestPublic(
      API_URL_Wasabi + "/DownloadFile",
      "post",
      {
        BucketPath: data.BucketPath,
      },
      "Download"
    )
      .then((response) => {
        setIsLoading(false);

        if (response.type === "application/txt") {
          const blob = response;
          const reader = new FileReader();
          reader.onload = () => {
            const content = reader.result;
            setTxtFile(content);
          };

          reader.readAsText(blob, "utf-8");
        } else if (response.type === "application/png") {
          const blob = response;
          const objectURL = URL.createObjectURL(blob);
          setImgFile(objectURL);
        } else if (response.type === "application/tiff") {
          const blob = response;
          const objectURL = URL.createObjectURL(blob);
          setImgFile(objectURL);
        } else if (response.type === "application/pdf") {
          const blob = response;
          const objectURL = URL.createObjectURL(blob);
          setPdfFile(objectURL);
        } else {
          let file = new Blob([response]);
          const fileUrl = URL.createObjectURL(file);
          setPdfFile(fileUrl);
        }
        setModalActive(true);
      })
      .catch((error) => {
        setIsLoading(false);
        NotificationHandler("File Not Found", enumUtil.enumtoaster.error);
      });
  };

  useEffect(() => {
    if (selectReply.length === 0) {
      setOpenReply(false);
      setOpen(true);
      setParentIID(null);
    }
  }, [selectReply])

  let openSubTabData = {
    name: `${mainTaskmanagementmodel.TaskFor === "Patient"
      ? "Patient"
      : `${mainTaskmanagementmodel.TaskFor}s`
      }`,
    data: {
      id:
        TaskSaveupdatemodel.VisitID ||
        TaskSaveupdatemodel.PatientID ||
        TaskSaveupdatemodel.PaymentID ||
        subTabID,
      name:
        mainTaskmanagementmodel.VisitID ||
        mainTaskmanagementmodel.PatientName ||
        mainTaskmanagementmodel.TRNCheckNumber,
      ...((props?.type ||
        mainTaskmanagementmodel.PaymentType ||
        TaskSaveupdatemodel.PaymentType) && {
        checkType:
          props?.type ||
          mainTaskmanagementmodel.PaymentType ||
          TaskSaveupdatemodel.PaymentType,
      }),
    },
  };
  const [openTab, setOpenTab] = useState('')

  const handleCreateClaim = (Data) => {
    let dataForClaim = {
      EncounterID: Data?.EncounterID,
      PatientID: Data?.PatientID,
      PatientName: Data?.PatientName,
    }
    let dataObj = {
      key: 2,
      name: "Claims",
      active: true,
      data: {
        name: "New Professional",
        id: -1,
        time: new Date(),
        visitType: "P",
        EncounterID: dataForClaim
      },
    };
    setOpenTab(dataObj)
    setTimeout(() => {
      IsClosed()
    }, 50);
  }
  const handleOpenPatient = (data) => {
    let objj = {
      active: true,
      key: 2,
      name: "Patient",
      data: {
        name: "All Patient",
        id: 0,
        time: new Date(),
      },
    }

  }
  return (
    <>
      {DeleteConfirmation}
      {DeleteConfirmations}
      {IntakePreviewPopup}
      {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}

      <Modal
        show={IsOpen}
        onHide={IsClosed}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName={`app-modal modal-lg hk-modal-v1 new_task_modal ${activitypopup ? "activity_popup" : ""
          }`}
      >
        {AuditPopup}
        <Modal.Body>
          <ModalHeader
            HeaderName={setTaskName}
            isOpenAudit={isOpenAudit}
            handleAuditModal={handleAuditModal}
            DeletePopup={view === "IntakeTasks" || view === "PendingSuperbills" || view === "UnsignedTasks" ? '' : DeletePopup}
            isClosed={onTasksave ? onDeleteTask : IsClosed}
            key={12}
            Name={"Task"}
            HideAuditIcon={"Task"}
          />
          <SearchHeader masterListButton={newTask} />
          {/* app-modal modal-lg hk-modal-v1 */}
          {isLoading ? <Loader /> : null}
          {!isNull(taskID) ? <div
            className={`ar-btn-position ${activitypopup ? "d-none" : ""}`}
            onClick={handleActivePopup}
          >
            <div className="ar-task-coment-icon d-flex justify-content-center align-items-center">
              <span class="icon-task-comment fs-15"><span class="path1"></span><span class="path2"></span></span>
            </div>
          </div> : <></>}

          <div className="row">
            <div className="left">
              <div className="col-md-12">
                <div
                  className={
                    taskValidationModal.taskCodeVal
                      ? "form-group input error"
                      : "form-group input mb-2"
                  }
                >
                  <label>
                    Task Title<span className="req">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="form-control mt-1"
                    name="Task"
                    id="Task"
                    autoComplete="off"
                    value={mainTaskmanagementmodel.Task}
                    onChange={handleOnChange}
                  />
                  {taskValidationModal.taskCodeVal}
                </div>
              </div>
              <div className="row justify-content-lg-between p-0">
                <div className="col-md-6 assign_task">
                  <div className="form-group input mb-2 position-relative">
                    <label>
                      Assign to<span className="req">*</span>
                    </label>
                    <div
                      className={
                        taskValidationModal.taskAssigneeVal
                          ? "form-group input error"
                          : "d-flex gap-3 position-relative"
                      }
                    >
                      <SuperSearchList
                        type="client"
                        id="Assignee"
                        name="Assignee"
                        searchValue={mainTaskmanagementmodel.Assignee}
                        data={DropdownData.User}
                        is={is}
                        onChange={handleSuperlist}
                        getSelectedData={handleSelectedData}
                        sup_btn="sup_btn-Inp"
                        sup_inp="superSearchVisitInp"
                        disabled={true}
                        inputError={taskValidationModal.taskAssigneeVal}
                      />
                      {taskValidationModal.taskAssigneeVal}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div
                    className={
                      taskValidationModal.taskTaskForVal
                        ? "form-group input error"
                        : "form-group input mb-2 position-relative"
                    }
                  >

                    <label> Category<span className="req">*</span></label>
                    <SuperSearchList
                      type="client"
                      id="TaskFor"
                      name="TaskFor"
                      searchValue={mainTaskmanagementmodel.TaskFor}
                      data={TaskData}
                      onChange={handleSuperlist}
                      getSelectedData={handleSelectedData}
                      // is={is}
                      sup_btn="sup_btn-Inp"
                      sup_inp="superSearchVisitInp"
                      inputError={taskValidationModal.taskTaskForVal}
                      isReadOnly={mainTaskmanagementmodel.IsSystemGenerated === 'True' ? true : false}
                    />
                    {taskValidationModal.taskTaskForVal}
                  </div>
                </div>

              </div>

              {/* {isHomeCareCheck === 'true' ? null : */}
              <div className="row justify-content-lg-between p-0">
                <div className="col-md-12 pateint-serach-no-rounded">
                  <div className={`form-group mb-2 input position-relative ${taskValidationModal?.AdditionalIDs ? 'error' : ""}`}>
                    <div className="d-flex align-items-center label-head">
                      <label>
                        {mainTaskmanagementmodel.TaskFor === "Claim"
                          ? "Claim #"
                          : mainTaskmanagementmodel.TaskFor === "Payment"
                            ? "Check #"
                            : mainTaskmanagementmodel.TaskFor === "Caregiver"
                              ? "Caregiver"
                              : mainTaskmanagementmodel.TaskFor === "Patient"
                                ? "Patient"
                                : mainTaskmanagementmodel.TaskFor === "Other"
                                  ? "Other" : ""}
                        {/* {openSubTabData?.data?.id ? (
                        <i
                          className="icon-icon-arrow-top-right ar-icon-blue"
                          onClick={() => {
                            handleOpenNewBrowserTab(openSubTabData);
                          }}
                        ></i>
                      ) : (
                        <></>
                      )} */}
                        {mainTaskmanagementmodel?.TaskFor && !["Patient Intake", "Unsigned Encounter", "Claim not created"].includes(mainTaskmanagementmodel?.TaskFor) ? <span className="req">*</span> : ""}
                      </label>
                      {!isNull(TaskSaveupdatemodel.AdditionalIDs) ?
                        mainTaskmanagementmodel.TaskFor === "Claim" ?
                          <i className="icon-icon-arrow-top-right" onClick={() => {
                            openSidebarSubMainTab(`Claims-71-{"ClaimNumber":"${TaskSaveupdatemodel.AdditionalIDs}"}`);
                            IsClosed()
                          }}>
                          </i>
                          : mainTaskmanagementmodel.TaskFor === "Payment" ?
                            <i className="icon-icon-arrow-top-right" onClick={() => {
                              openSidebarSubMainTab(
                                `Payments-73-${JSON.stringify({
                                  CheckNumber: mainTaskmanagementmodel.AdditionalIDs.map(x => x.display).join(',')
                                })}`
                              );
                              IsClosed()
                            }}>
                            </i>
                            : mainTaskmanagementmodel.TaskFor === "Patient" ?
                              <i className="icon-icon-arrow-top-right" onClick={() => {
                                openSidebarSubMainTab(
                                  `Patient-2-${JSON.stringify({
                                    SearchCeriteria: mainTaskmanagementmodel.AdditionalIDs.map(x => x.AccountNumber).join(',')
                                  })}`
                                );
                                IsClosed()
                              }}>
                              </i>
                              : null
                        : null
                      }
                    </div>


                    {mainTaskmanagementmodel.TaskFor === "Claim" ? (
                      // <>
                      //   <SuperSearchList
                      //     type="server"
                      //     id="VisitID"
                      //     name="VisitID"
                      //     searchValue={mainTaskmanagementmodel.VisitID}
                      //     ApiLink={API_URL_General + "/SearchDataForTask"}
                      //     method="post"
                      //     postBody={visitBody}
                      //     onChange={handleVisitChange}
                      //     getSelectedData={handleSelectedClaimInfoData}
                      //     is={is}
                      //     sup_btn="sup_btn-Inp"
                      //     sup_inp="superSearchVisitInp"
                      //     disabled={true}
                      //     placeholder={false}
                      //   // isReadOnly={true}
                      //   />
                      //   <i className="icon-Clip-path-group search_icon"></i>
                      // </>
                      <>

                        <SuperSearchMultipleServer
                          key={`${reloadSuperSearchClaim}-Claim`}
                          id="AdditionalIDs"
                          name="AdditionalIDs"
                          SuperSearchView="DetailedView"
                          DetailedView="Claim"
                          initialSelectedOptionsInstant={VisitValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                          searchParam={TaskSaveupdatemodel}
                          setSearchParam={setTaskSaveupdatemodel}
                          tableName={enumUtil.enumAPITableName.Task} //send Tablename api
                          controller={API_URL_General}
                          ApiLink={"/SearchDataForTask"} //api url 
                          postBody={visitBody}
                          type={"Claim"}
                          method='post'  //   api method
                          sup_btn='sup_btn-Inp'
                          sup_inp='superSearchVisitInp'
                        />
                        <i className="icon-Clip-path-group search_icon"></i>
                      </>
                    ) : mainTaskmanagementmodel.TaskFor === "Payment" ? (
                      // <SuperSearchList
                      //   type="server"
                      //   id="PaymentID"
                      //   name="PaymentID"
                      //   searchValue={mainTaskmanagementmodel.PaymentID}
                      //   ApiLink={API_URL_General + "/SearchDataForTask"}
                      //   method="post"
                      //   postBody={paymentBody}
                      //   onChange={handlePaymentChange}
                      //   getSelectedData={handleSelectedClaimInfoData}
                      //   is={is}
                      //   sup_btn="sup_btn-Inp"
                      //   sup_inp="superSearchVisitInp"
                      //   disabled={true}
                      //   placeholder={false}
                      // // isReadOnly={true}
                      // />
                      <>
                        <SuperSearchMultipleServer
                          key={`${reloadSuperSearchPayment}-Payment`}
                          id="AdditionalIDs"
                          name="AdditionalIDs"
                          SuperSearchView="DetailedView"
                          DetailedView="Payment"
                          initialSelectedOptionsInstant={PaymentValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                          searchParam={TaskSaveupdatemodel}
                          setSearchParam={setTaskSaveupdatemodel}
                          tableName={enumUtil.enumAPITableName.Task} //send Tablename api
                          controller={API_URL_General}
                          ApiLink={"/SearchDataForTask"} //api url 
                          postBody={paymentBody}
                          type={"Payment"}
                          method='post'  //   api method
                          sup_btn='sup_btn-Inp'
                          sup_inp='superSearchVisitInp'
                        />
                        <i className="icon-Clip-path-group search_icon"></i>
                      </>
                    ) : mainTaskmanagementmodel.TaskFor === "Caregiver" ? (
                      // <SuperSearchList
                      //   type="server"
                      //   id="CaregiverID"
                      //   name="CaregiverID"
                      //   searchValue={mainTaskmanagementmodel.CaregiverID}
                      //   ApiLink={API_URL_General + "/SearchDataForTask"}
                      //   method="post"
                      //   postBody={caregiverBody}
                      //   onChange={handleCaregiverChange}
                      //   getSelectedData={handleSelectedClaimInfoData}
                      //   is={is}
                      //   sup_btn="sup_btn-Inp"
                      //   sup_inp="superSearchVisitInp"
                      //   disabled={true}
                      //   placeholder={false}
                      // // isReadOnly={true}
                      // />
                      <>
                        <SuperSearchMultipleServer
                          key={`${reloadSuperSearchCaregiver}-Caregiver`}
                          id="AdditionalIDs"
                          name="AdditionalIDs"
                          SuperSearchView="DetailedView"
                          DetailedView="Caregiver"
                          initialSelectedOptionsInstant={CaregiverValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                          searchParam={TaskSaveupdatemodel}
                          setSearchParam={setTaskSaveupdatemodel}
                          tableName={enumUtil.enumAPITableName.CareGiver} //send Tablename api
                          controller={API_URL_General}
                          ApiLink={"/SearchDataForTask"} //api url 
                          method='post'  //   api method
                          sup_btn='sup_btn-Inp'
                          sup_inp='superSearchVisitInp'
                        />
                        <i className="icon-Clip-path-group search_icon"></i>
                      </>
                    ) : mainTaskmanagementmodel.TaskFor === "Patient" ? (
                      <>

                        <SuperSearchMultipleServer
                          key={`${reloadSuperSearchPatient}-Patient`}
                          id="AdditionalIDs"
                          name="AdditionalIDs"
                          SuperSearchView="DetailedView"
                          DetailedView="PatientTask"
                          initialSelectedOptionsInstant={PatientValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                          searchParam={TaskSaveupdatemodel}
                          setSearchParam={setTaskSaveupdatemodel}
                          tableName={enumUtil.enumAPITableName.Task} //send Tablename api
                          controller={API_URL_General}
                          ApiLink={"/SearchDataForTask"} //api url 
                          method='post'  //   api method
                          postBody={patientBody}
                          type={"PatientTask"}
                          sup_btn='sup_btn-Inp'
                          sup_inp='superSearchVisitInp'
                        />
                        <i className="icon-Clip-path-group search_icon"></i>
                      </>
                    ) :
                      mainTaskmanagementmodel.TaskFor === "Patient Intake" ? (
                        <div className="d-flex flex-column gap-6 pateint-intake-detail px-1 py-1-5 mb-2">
                          <div className="d-flex align-items-center justify-content-between">

                            <p className='text'>{mainTaskmanagementmodel?.AppointmentDate + ' - ' + mainTaskmanagementmodel?.AppointmentType} </p>
                            <button className="btn btn-validate h-100 min-w-unset px-2 rounded" onClick={() => handleIntakePreview(mainTaskmanagementmodel?.GuidID, mainTaskmanagementmodel?.PatientIntakeFormID, mainTaskmanagementmodel?.PatientID, mainTaskmanagementmodel?.Status)}>Review</button>
                            {/* <button className="btn btn-orange h-100 min-w-unset px-2 rounded">Sign</button> */}
                          </div>
                          <div className="d-flex align-items-center gap-1">
                            <p className='heading'>Patient:</p>
                            <p className='text'>{`${mainTaskmanagementmodel?.PatientName} ${mainTaskmanagementmodel?.DOB} ${mainTaskmanagementmodel?.Age ? '(' + mainTaskmanagementmodel?.Age + ')' : ''} ${mainTaskmanagementmodel?.Gender}`}</p>
                          </div>
                          <div className="d-flex align-items-center gap-1">
                            <p className='heading'>Provider:</p>
                            <p className='text'>{mainTaskmanagementmodel?.ProviderName}</p>
                          </div>
                        </div>
                      ) : mainTaskmanagementmodel.TaskFor === "Unsigned Encounter" || mainTaskmanagementmodel.TaskFor === "Unsubmitted Superbill" || mainTaskmanagementmodel.TaskFor === "Claim not created" ? (
                        <div className="d-flex flex-column gap-6 pateint-intake-detail px-1 py-1-5 mb-2">
                          <div className="d-flex align-items-center justify-content-between">
                            <p className='text'>{mainTaskmanagementmodel?.EncounterDate + ' - ' + mainTaskmanagementmodel?.EncounterType}</p>
                            {mainTaskmanagementmodel.TaskStatus !== 'Closed' ?
                              <>
                                {
                                  mainTaskmanagementmodel.TaskFor === "Unsigned Encounter" ?
                                    <button className="btn btn-orange h-100 min-w-unset px-2 rounded" onClick={() => handleOpenEncounter(mainTaskmanagementmodel)}>Sign </button> : mainTaskmanagementmodel.TaskFor === "Unsubmitted Superbill" ?
                                      <button className="btn btn-orange h-100 min-w-unset px-2 rounded" onClick={() => handleOpenEncounter(mainTaskmanagementmodel)}> Add Superbill </button> : mainTaskmanagementmodel.TaskFor === "Claim not created" ?
                                        <button className="btn btn-orange h-100 min-w-unset px-2 rounded" onClick={() => handleCreateClaim(mainTaskmanagementmodel)}> Create Claim </button> : null

                                }
                              </>
                              : null}
                          </div>
                          <div className="d-flex align-items-center gap-15">
                            <div className="d-flex align-items-center gap-1">
                              <p className='heading'>Provider:</p>
                              <p className='text'>{mainTaskmanagementmodel?.ProviderName}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                              <p className='heading'>Location:</p>
                              <p className='text'>{mainTaskmanagementmodel?.LocationName}</p>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-1">
                            <p className='heading'>Chief Complaint:</p>
                            <p className='text'>{mainTaskmanagementmodel?.ChiefComplaint}</p>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="form-group input">
                            <input className="form-control" id='OtherDetails' name='OtherDetails' value={mainTaskmanagementmodel.OtherDetails} onChange={(e) => handleOnChange(e)} />
                          </div>
                          {/* <SuperSearchMultipleServer
                          key={reloadSuperSearchPatient}
                          id="AdditionalIDs"
                          name="AdditionalIDs"
                          SuperSearchView="DetailedView"
                          DetailedView="PatientTask"
                          initialSelectedOptionsInstant={PatientValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                          searchParam={TaskSaveupdatemodel}
                          setSearchParam={setTaskSaveupdatemodel}
                          tableName={enumUtil.enumAPITableName.Task} //send Tablename api
                          controller={API_URL_General}
                          ApiLink={"/SearchDataForTask"} //api url 
                          method='post'  //   api method
                          postBody={patientBody}
                          type={"PatientTask"}
                          sup_btn='sup_btn-Inp'
                          sup_inp='superSearchVisitInp'
                        />
                        <i className="icon-Clip-path-group search_icon"></i> */}
                        </>
                      )}
                    {taskValidationModal?.AdditionalIDs}
                    {/* <input type="text" className="form-control mt-1" name="LocationName" id="LocationName" value="" /> */}
                  </div>
                </div>
              </div>
              {/* } */}
              <div className="col-md-12 description">
                <div className="form-group mb-2 input">
                  <TextEditor
                    value={mainTaskmanagementmodeld.Description}
                    setValue={(value) =>
                      handleOnChanged({
                        target: { name: "Description", value },
                      })
                    }
                  />
                </div>
              </div>
              <div className="row ">
                <div className="col-md-4">
                  <div className={`form-group input mb-2 position-relative ${taskValidationModal?.DueDate ? 'error' : ''}`}>
                    <DatePicker
                      label={<>Due Date<span className='req'>*</span></>}
                      value={mainTaskmanagementmodel.DueDate}
                      handleCalendarChangefunc={(date) =>
                        handleCalendarChange(date, "DueDate")
                      }
                      minDate={new Date()}
                      inputError={taskValidationModal?.DueDate ? true : false}
                    />

                    {taskValidationModal?.DueDate}
                  </div>
                </div>

                <div className="col-md-4 za-ticket-status">
                  {taskID > 0 ? (
                    <>
                      <div className="form-group input mb-2 position-relative">
                        <label>Task Status </label>
                        <SuperSearchList
                          type="client"
                          id="TaskStatus"
                          name="TaskStatus"
                          searchValue={mainTaskmanagementmodel.TaskStatus}
                          data={TaskStatus}
                          is={is}
                          onChange={handleSuperlist}
                          getSelectedData={handleSelectedData}
                          sup_btn="sup_btn-Inp"
                          sup_inp="superSearchVisitInp"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="form-group input mb-2 position-relative">
                        <label>Task Status </label>
                        <SuperSearchList
                          type="client"
                          id="TaskStatus"
                          name="TaskStatus"
                          searchValue={mainTaskmanagementmodel.TaskStatus}
                          data={TaskStatus}
                          is={true}
                          isReadOnly={isReadOnly}
                          onChange={handleSuperlist}
                          getSelectedData={handleSelectedData}
                          sup_btn="sup_btn-Inp"
                          sup_inp="superSearchVisitInp"
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="col-md-4 za-priority">
                  <div className={`form-group input mb-2 position-relative ${taskValidationModal?.Priority ? 'error' : ''}`}>
                    <label>Priority<span className="req">*</span></label>
                    <SuperSearchList
                      type="client"
                      id="Priority"
                      name="Priority"
                      PriorityInst={true}
                      searchValue={mainTaskmanagementmodel.Priority}
                      data={Priority}
                      onChange={handleSuperlist}
                      getSelectedData={handleSelectedData}
                      is={is}
                      sup_btn="sup_btn-Inp"
                      sup_inp="superSearchVisitInp"
                      inputError={taskValidationModal?.Priority ? true : false}
                    />

                    {taskValidationModal?.Priority}
                  </div>
                </div>
              </div>

              {/* <div className="row assign_task">
                            <div className="form-group input mb-2 position-relative">
                                <label>Assign this task to </label>
                                <div className="d-flex gap-3">
                                    <Autocomplete
                                        multiple
                                        id="Assignee"
                                        options={DropdownData.User}
                                        fullWidth={true}
                                        value={assign}
                                        getOptionLabel={(option) => option.display}
                                        onChange={(event, value) => handleMultipleSelect(value, 'Assignee')}
                                        // onChange={(event, values) => handleSelect(values)}
                                        // renderInput={(params) => <TextField {...params} variant="standard" onChange={(e) => handlePatientInstantSearch(e, 'Assignee')} />}
                                        renderInput={(params) => <TextField {...params} label="Select Options " />}
                                    />
                                    <p className="heading select_user"><i className="icon-person-svgrepo-com-1"></i> Select User</p>
                                </div>
                            </div>
                        </div> */}


              <div className="row attachment_doc p-0 pb-15">
                <div className="form-group input mb-2 position-relative">
                  <label>Attach Document</label>
                  <div className="d-flex justify-content-lg-between">

                    {Files?.length > 0 && (
                      <div className="d-flex doc_items">
                        {Files?.map((file, index) => (
                          <div
                            className="doc_name d-flex align-items-center"
                            key={index}
                          >
                            <p
                              className="m-0 trancation"
                              title={file?.name ?? file?.item?.FileName}
                            >
                              {file?.name ?? file?.item?.FileName}
                            </p>
                            <i
                              className="icon-close"
                              onClick={() => removeFile(index)}
                            ></i>
                            {(!isNull(taskID) && file?.item?.TaskAttachmentsID) ? (
                              <img
                                src={downloadicon}
                                onClick={() =>
                                  DownloadFile(
                                    file.item.TaskAttachments,
                                    file.item.FileName
                                  )
                                }
                              />
                            ) : null}
                          </div>
                        ))}
                        <i
                          className="icon-plus-icon add_new_doc"
                          onClick={() => inputRef.current.click()}
                        ></i>
                      </div>
                    )}

                    <input
                      type="file"
                      className="ps-3 form-control doc_input w-100"
                      placeholder="Upload a file"
                      multiple
                      name="Files"
                      id="Files"
                      ref={inputRef}
                      accept=".png, .txt, .pdf"
                      onChange={(e) => {
                        handleFileChange(e);
                      }}
                    />
                    {/* {Files?.length > 0 && (
                                        <div>
                                            {Files?.map((file, index) => (
                                                <p key={index}>
                                                    <i className="icon-Icon-metro-cross" onClick={() => removeFile(index)}></i> {file?.name}
                                                </p>
                                            ))}
                                        </div>
                                    )} */}
                    {/* <p className="text select_user">image.png<i className="icon-Icon-metro-cross"></i></p> */}

                    <i className="icon-Icon-metro-attachment"></i>
                  </div>
                </div>
                <div>
                  {/* text xsm_text ar-light-color */}
                  {!isNull(taskID) ? <p className="text xsm_text ar-light-color">
                    To Add comment,{" "}
                    <span
                      className={
                        taskID === 0
                          ? `cursor-pointer font-sb heading xsm_heading`
                          : `ar-found-text cursor-pointer font-sb heading xsm_heading`
                      }
                      onClick={handleActivePopup}
                    >
                      Click Here
                    </span>{" "}
                  </p> : <></>}
                </div>
              </div>
            </div>
            <div className="right br-left-1 ar-border-color">
              {activitypopup && (
                <>
                  <div className="ar-activity-box pt-3 border-start-0">
                    <div className="position-relative">
                      <div
                        className="activity_icon"
                        onClick={() => setActivitypopup(false)}
                      >
                        <div className="ar-task-coment-icon d-flex justify-content-center align-items-center">
                          <span class="icon-task-comment fs-15"><span class="path1"></span><span class="path2"></span></span>
                        </div>
                      </div>
                      <p className="heading px-3 mb-1">Activity</p>
                      <div className="ar-act-head "></div>
                      {oepnReply === true ? (
                        <>
                          <span
                            className="back_to_mes"
                            onClick={() => handleBack()}
                          >
                            <i className="icon-Icon-ionic-md-arrow-round-back"></i>
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className={oepnReply ? `ar-taskreply` : ``}>
                      <div className="ar-activity-overflow">
                        {oepnReply === true &&
                          selectReply?.map((item) => {
                            handleNameSplit(item.Name);
                            let replyComment = commentData.filter(
                              (values) =>
                                values.ParentID === item.TaskCommentsID
                            );

                            if (!item.ParentID) {

                              return (
                                <>
                                  <div className="px-2">
                                    <div className="ar-row">
                                      <div className="d-flex gap-1 align-items-baseline ">
                                        <div className="ar-text-box d-flex align-items-center justify-content-center">
                                          <p className="text">
                                            {nameFf}
                                            {nameLl}
                                          </p>
                                        </div>
                                        <div>
                                          <p className="heading">{item.Name}</p>
                                        </div>
                                      </div>
                                      <div>
                                        <p className="text xsm_text ar-light-color">
                                          {timeSince(item.EnteredDate)}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="ps-1 ms-4 ">
                                      {/* <p className="heading ar-dark-color">@TAimoorAzhar </p>  */}

                                      {/* <p className="heading ar-dark-color">@TAimoor Azhar <span className="text ar-light-color"> {item.Comment}</span></p> */}
                                      <p className="mb-2 validation_message">
                                        <span className="text ar-light-color">
                                          {" "}
                                          {item.Comment}
                                        </span>
                                      </p>
                                    </div>
                                    {item.BucketPath && item.BucketPath.toLowerCase().endsWith('.jpeg') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.png') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.jpg')
                                      || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.JPG') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.JPEG') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.PNG') ? (
                                      <div className="ar-filetype-ind ">
                                        <div className='d-flex align-items-center gap-2'>
                                          <i className='icon-image fs-22'></i>
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>PNG</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : item.BucketPath && item.BucketPath.toLowerCase().endsWith('.pdf') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.PDF') ? (
                                      <div className="ar-filetype-ind ">
                                        <div className='d-flex align-items-center gap-2'>
                                          <PDF />
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>PDF</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : item.BucketPath && (item.BucketPath.toLowerCase().endsWith('.docx') || item.BucketPath.toLowerCase().endsWith('.doc')) || item.BucketPath.toLowerCase().endsWith('.DOC') || item.BucketPath.toLowerCase().endsWith('.DOCX') ? (
                                      <div className="ar-filetype-ind ">
                                        <div className='d-flex align-items-center gap-2'>
                                          <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Word</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : item.BucketPath && (item.BucketPath.toLowerCase().endsWith('.xls') || item.BucketPath.toLowerCase().endsWith('.xlsx')) || item.BucketPath && (item.BucketPath.toLowerCase().endsWith('.XLS')) || item.BucketPath && (item.BucketPath.toLowerCase().endsWith('.XLSX')) ? (
                                      <div className="ar-filetype-ind ">
                                        <div className='d-flex align-items-center gap-2'>
                                          <i className='icon-excel fs-21 text-success'></i>
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Excel</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : item.BucketPath && item.BucketPath.toLowerCase().endsWith('.txt') || item.BucketPath && item.BucketPath.toLowerCase().endsWith('.TXT') ? (
                                      <div className="ar-filetype-ind">
                                        <div className='d-flex align-items-center gap-2'>
                                          <Textfile />
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Text</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                      : item.BucketPath && <div className="ar-filetype-ind ">
                                        <div className='d-flex align-items-center gap-2'>
                                          {/* <i className='icon-excel fs-21 text-success'></i> */}
                                          <div>
                                            <p className="text fs-13 font-m" onClick={() => handleDownloadFile(item.BucketPath, item)}>{item.BucketPath.split("/").pop()}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>UnKown</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>}


                                    <div className="ar-row align-items-center mt-1">
                                      <div className="d-flex align-items-center gap-1 ">
                                        <span className="ar-line"></span>
                                        <p className="text xsm_text ar-light-color">
                                          {!isNull(replyComment.length) ? replyComment.length : ""} Add Reply
                                        </p>
                                        {/* onClick={() => { handleReply(value.TaskCommentsID, value) }} */}
                                      </div>
                                      <div className="d-flex ar-btn">
                                        <button
                                          class="btn-icon-transparent"
                                          onClick={() =>
                                            handleUpdateCommentreply(
                                              item.TaskCommentsID,
                                              item.Comment,
                                              item
                                            )
                                          }
                                        >
                                          <i class="icon-edit-pencil me-1 fs-12"></i>
                                        </button>
                                        <button class="btn-icon-transparent">
                                          <i
                                            class="icon-delete fs-12 text-danger"
                                            onClick={() =>
                                              handleDelete(item.RecordID)
                                            }
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {replyComment.map((value) => {
                                    handleNameSplit(value.Name);
                                    return (
                                      <>
                                        <div className="reply">
                                          <div className="ar-row">
                                            <div className="d-flex gap-1 align-items-baseline ">
                                              <div className="ar-text-box d-flex align-items-center justify-content-center">
                                                <p className="text">
                                                  {nameFf}
                                                  {nameLl}
                                                </p>
                                              </div>
                                              <div>
                                                <p className="heading">
                                                  {value.Name}
                                                </p>
                                              </div>
                                            </div>
                                            <div>
                                              <p className="text xsm_text ar-light-color">
                                                {timeSince(value.EnteredDate)}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="d-flex justify-content-between ">
                                            <div className="ps-1 ms-4 ">
                                              {/* <p className="heading ar-dark-color">@TAimoor Azhar <span className="text ar-light-color"> {item.Comment}</span></p> */}
                                              <p className="mb-2 validation_message">
                                                <span className="text ar-light-color">
                                                  {" "}
                                                  {value.Comment}
                                                </span>
                                              </p>
                                            </div>

                                            <div className="ar-row align-items-center mt-1">
                                              <div className="d-flex align-items-center gap-1 "></div>
                                              <div className="d-flex ar-btn">
                                                <button class="btn-icon-transparent">
                                                  <i
                                                    class="icon-edit-pencil fs-12 me-1"
                                                    onClick={() =>
                                                      handleUpdateCommentreply(
                                                        value.TaskCommentsID,
                                                        value.Comment,
                                                        value
                                                      )
                                                    }
                                                  ></i>
                                                </button>
                                                <button class="btn-icon-transparent">
                                                  <i
                                                    class="icon-delete text-danger fs-12"
                                                    onClick={() =>
                                                      handleDelete(
                                                        value.RecordID
                                                      )
                                                    }
                                                  ></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                          {value.BucketPath && value.BucketPath.toLowerCase().endsWith('.jpeg') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.png') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.jpg')
                                            || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.JPG') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.JPEG') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.PNG') ? (
                                            <div className="ar-filetype-ind ">
                                              <div className='d-flex align-items-center gap-2'>
                                                <i className='icon-image fs-22'></i>
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>PNG</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : value.BucketPath && value.BucketPath.toLowerCase().endsWith('.pdf') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.PDF') ? (
                                            <div className="ar-filetype-ind ">
                                              <div className='d-flex align-items-center gap-2'>
                                                <PDF />
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>PDF</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.docx') || value.BucketPath.toLowerCase().endsWith('.doc')) || value.BucketPath.toLowerCase().endsWith('.DOC') || value.BucketPath.toLowerCase().endsWith('.DOCX') ? (
                                            <div className="ar-filetype-ind ">
                                              <div className='d-flex align-items-center gap-2'>
                                                <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>Word</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.xls') || value.BucketPath.toLowerCase().endsWith('.xlsx')) || value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.XLS')) || value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.XLSX')) ? (
                                            <div className="ar-filetype-ind ">
                                              <div className='d-flex align-items-center gap-2'>
                                                <i className='icon-excel fs-21 text-success'></i>
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>Excel</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : value.BucketPath && value.BucketPath.toLowerCase().endsWith('.txt') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.TXT') ? (
                                            <div className="ar-filetype-ind">
                                              <div className='d-flex align-items-center gap-2'>
                                                <Textfile />
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>Text</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                            : value.BucketPath && <div className="ar-filetype-ind ">
                                              <div className='d-flex align-items-center gap-2'>
                                                {/* <i className='icon-excel fs-21 text-success'></i> */}
                                                <div>
                                                  <p className="text fs-13 font-m" onClick={() => handleDownloadFile(value.BucketPath, value)}>{value.BucketPath.split("/").pop()}</p>
                                                  <div className='d-flex align-items-center gap-40'>
                                                    {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                                    <p className='text fs-10 ar-light-text fs-11'>UnKown</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>}
                                        </div>
                                      </>
                                    );
                                  })}
                                </>
                              );
                            }

                          })}
                        {oepn &&
                          commentData.map((value) => {
                            handleNameSplit(value.Name);
                            if (!value.ParentID)
                              return (
                                <>
                                  <div className="px-2 mt-3">
                                    <div className="ar-row">
                                      <div className="d-flex gap-1 align-items-baseline ">
                                        <div className="ar-text-box d-flex align-items-center justify-content-center">
                                          <p className="text">
                                            {nameFf}
                                            {nameLl}
                                          </p>
                                        </div>

                                        <div>
                                          <p className="heading">
                                            {value.Name}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="d-flex align-items-center gap-1">
                                        {value?.Edit === "True" ? (
                                          <p className="text xsm_text ar-light-color">
                                            Edited
                                          </p>
                                        ) : null}

                                        <p className="text xsm_text ar-light-color">
                                          {timeSince(value.EnteredDate)}
                                        </p>
                                        {value?.BucketPath ? <i
                                          class="icon-Icon-awesome-eye fs-10"
                                          onClick={() => ViewFile(value)}
                                        ></i> : <></>}
                                      </div>
                                    </div>
                                    <div className="ps-1 ms-4 ">
                                      {/* <p className="heading ar-dark-color">@TAimoor Azhar <span className="text ar-light-color"> {item.Comment}</span></p> */}
                                      <p className="mb-2 validation_message">
                                        <span className="text ar-light-color">
                                          {" "}
                                          {value.Comment}
                                        </span>
                                      </p>
                                    </div>

                                    {value.BucketPath && value.BucketPath.toLowerCase().endsWith('.jpeg') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.png') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.jpg')
                                      || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.JPG') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.JPEG') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.PNG') ? (
                                      <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          <i className='icon-image fs-22'></i>
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>PNG</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : value.BucketPath && value.BucketPath.toLowerCase().endsWith('.pdf') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.PDF') ? (
                                      <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          <PDF />
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>PDF</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.docx') || value.BucketPath.toLowerCase().endsWith('.doc')) || value.BucketPath.toLowerCase().endsWith('.DOC') || value.BucketPath.toLowerCase().endsWith('.DOCX') ? (
                                      <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Word</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.xls') || value.BucketPath.toLowerCase().endsWith('.xlsx')) || value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.XLS')) || value.BucketPath && (value.BucketPath.toLowerCase().endsWith('.XLSX')) ? (
                                      <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          <i className='icon-excel fs-21 text-success'></i>
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Excel</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : value.BucketPath && value.BucketPath.toLowerCase().endsWith('.txt') || value.BucketPath && value.BucketPath.toLowerCase().endsWith('.TXT') ? (
                                      <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          <Textfile />
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>Text</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                      : value.BucketPath && <div className="ar-filetype-ind cursor-pointer" onClick={() => handleDownloadFile(value.BucketPath, value)}>
                                        <div className='d-flex align-items-center gap-2'>
                                          {/* <i className='icon-excel fs-21 text-success'></i> */}
                                          <div>
                                            <p className="text fs-13 font-m" >{value?.FileName}</p>
                                            <div className='d-flex align-items-center gap-40'>
                                              {/* <p className='text fs-10 ar-light-text fs-11 '>18Mb</p> */}
                                              <p className='text fs-10 ar-light-text fs-11'>UnKown</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>}
                                    <div className="ar-row align-items-center mt-1">
                                      <div className="d-flex align-items-center gap-1 ">
                                        <span className="ar-line"></span>
                                        <p
                                          className="text xsm_text ar-light-color"
                                          onClick={() => {
                                            handleReply(
                                              value.TaskCommentsID,
                                              value
                                            );
                                          }}
                                        >
                                          {!isNull(value.Replycount) ? value.Replycount : ""} Add Reply
                                        </p>
                                      </div>
                                      <div className="d-flex ar-btn">
                                        <button
                                          class="btn-icon-transparent"
                                          onClick={() => {
                                            handleUpdateCommentreply(
                                              value.TaskCommentsID,
                                              value.Comment,
                                              value
                                            );
                                          }}
                                        >
                                          <i class="icon-edit-pencil fs-12 me-1"></i>
                                        </button>
                                        <button class="btn-icon-transparent">
                                          <i
                                            class="icon-delete text-danger fs-12"
                                            onClick={() =>
                                              handleDelete(value.RecordID)
                                            }
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                          })}
                      </div>
                    </div>
                    <div className="ar_file-task pb-2">
                      <div className="position-relative pt-1 px-10">
                        <div className="notes-content__item__Form">

                          {chatFile?.Files?.map((file, index) => {
                            let size, extension;

                            if (file && file.size) {
                              if (file.size < 1024 * 1024) {
                                // Size in KB for files smaller than 1 MB
                                size = `${(file.size / 1024).toFixed(2)} KB`;
                              } else {
                                // Size in MB for files larger than or equal to 1 MB
                                size = `${(file.size / (1024 * 1024)).toFixed(2)} MB`;
                              }
                              extension = file.name.split(".").pop(); // Get the file extension
                            }

                            return (
                              <div className='ar-notes-file-upload'>
                                <div className="d-flex align-items-center justify-content-between" key={index}>
                                  <div className='d-flex gap-2 align-items-center'>
                                    {/* <PDF /> */}
                                    {/* <i className='icon-image fs-22'></i> */}
                                    {/* <span class="icon-word fs-21"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span> */}
                                    {getFlieTypeIcon(getFileExtension(file))}
                                    <div>

                                      <p className="text fs-13 font-m pb-1 validation_message w-240px" title={file?.name ?? file?.item?.FileName}> {file?.name ?? file?.item?.FileName} </p>
                                      <div className='d-flex align-items-center gap-40'>
                                        <p className='text fs-10 ar-light-text fs-11 '>{size ? size : null}</p>
                                        <p className='text fs-10 ar-light-text fs-11'>{extension}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <i className='icon-Icon-metro-cross fs-13' onClick={() => removeFilechat(index)} ></i>
                                </div>
                              </div>
                            )

                          })}
                          <div className="position-relative d-flex input">
                            <textarea
                              rows="4"
                              className={`ar-texteara-act form-control ${crossIcon ? 'pe-74' : ''}`}
                              type="text"
                              placeholder={
                                oepnReply ? "Type your Reply" : "Type your comment"
                              }
                              name="Comment"
                              id="Comment"
                              onKeyDown={handleKey}
                              onChange={handleNoteChange}
                              value={mainNoteModal.Comment}
                            ></textarea>
                            <div className="d-flex align-items-center gap-1 ar_task-textarea-icon">
                              <button className="btn-icon-transparent attach-Btn position-relative">
                                <i className="icon-Icon-metro-attachment"></i>
                                <input
                                  type="file"
                                  // onChange={handleNotesFileChange}
                                  name="Files"
                                  id="Files"
                                  ref={inputRefComment}
                                  accept=".png, .txt, .pdf"
                                  onChange={(e) => {
                                    handleFileChangeChat(e);
                                  }}
                                  className="position-absolute top-0 bottom-0 start-0 end-0"

                                />
                              </button>

                              <div className="ar-icon-box">
                                <button className="btn-icon-transparent Round-Btn">
                                  <i
                                    className="icon-arrow-right2 "
                                    onClick={handleSaveNote}
                                  ></i>
                                </button>
                              </div>

                              {crossIcon ? (
                                <div
                                  className="ar_msg-edit-icon d-flex"
                                  onClick={() => {
                                    cleartext();
                                  }}
                                >
                                  {" "}
                                  <i className="icon-close fs-10"></i>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        {/*  icons {icon-image , icon-word, icon-pdf-chatbot} show on condtion*/}

                        {/* <button className="btn-icon-transparent attach-Btn za-img-Btn">
                          <i className="icon-image"></i>
                        </button>
                        <button className="btn-icon-transparent attach-Btn za-word-Btn">
                          <span class="icon-word"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>
                        </button>
                        <button className="btn-icon-transparent attach-Btn za-pdf-Btn">
                          <span class="icon-pdf-chatbot"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span></span>
                        </button> */}



                        {/* <textarea rows="4" className="ar-texteara-act" type="text"
                                                placeholder={oepnReply ? "Type your Reply" : "Type your comment"}
                                                name="Comment"
                                                id="Comment"
                                                onKeyDown={handleKey}
                                                value={mainNoteModal.Comment} onChange={handleNoteChange}>
                                            </textarea> */}
                        {showMentions && mentionList.length > 0 && (
                          <ul className="ar-task-mention d-flex flex-column gap-2">
                            {mentionList.map((user) => (
                              <li className="text"
                                key={user.value}
                                onClick={() => handleMentionClick(user)}
                              >
                                {user.display}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* <div className="col-12 br-clr br-top-1 pt-2 d-flex align-items-center  justify-content-between">
              {!isNull(taskID) ?
                <div className="update-info">
                  <p className="ms-1">
                    Recent Updated By:{" "}
                    <span className="position-relative">
                      {mainTaskmanagementmodel.UpdatedBy
                        ? mainTaskmanagementmodel.UpdatedBy
                        : "Name Name"}
                    </span>
                    <div className="tool_tip xsm_text text-light">{UpdatedBy ? UpdatedBy : 'Name Name'}</div>
                  </p>
                  <p className="ms-1">
                    Date:{"\u00A0\u00A0"}
                    <span>
                      {mainTaskmanagementmodel.UpdatedDate
                        ? mainTaskmanagementmodel.UpdatedDate.split("T")[0]
                        : "00/00/0000"}
                    </span>
                    {"\u00A0\u00A0"}
                    {"\u00A0\u00A0"}
                    <span>
                      {mainTaskmanagementmodel.UpdatedDate
                        ? mainTaskmanagementmodel.UpdatedDate.split("T")[1]
                        : "00:00 PM"}
                    </span>
                  </p>
                </div> : <div></div>}
              <div className="d-flex gap-10 align-items-center">
                <button
                  className="btn btn-gray"
                  onClick={onTasksave ? onDeleteTask : IsClosed}
                >
                  Cancel
                </button>
                <button
                  className={
                    IsEditAllowed ? "btn btn-orange " : "btn btn-orange disabled"
                  }
                  onClick={(e) => { onsubmitSaveDocument(e); handleNotes(e); }}
                >
                  Save
                </button>
              </div>
            </div> */}

          </div>
        </Modal.Body>

        <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-between ar_footer">
          <div>
            {!isNull(taskID) ?
              <div className="update-info gap-01">
                <p className="">
                  Updated By/Date:
                  {/* <div className="tool_tip xsm_text text-light">{UpdatedBy ? UpdatedBy : 'Name Name'}</div> */}
                </p>
                <p className="d-flex align-items-center gap-01">
                  <span className="position-relative is-empty">
                    {mainTaskmanagementmodel.UpdatedBy
                      ? mainTaskmanagementmodel.UpdatedBy + ","
                      : "Name Name, "}
                  </span>
                  <span className="is-empty">
                    {mainTaskmanagementmodel.UpdatedDate
                      ? mainTaskmanagementmodel.UpdatedDate.split("T")[0]
                      : "00/00/0000"}
                  </span>
                  <span className="is-empty">
                    {mainTaskmanagementmodel.UpdatedDate
                      ? mainTaskmanagementmodel.UpdatedDate.split("T")[1]
                      : "00:00 PM"}
                  </span>
                </p>
              </div> : <div></div>}
          </div>


          <div className="d-flex gap-2">
            <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onTasksave ? onDeleteTask : IsClosed}>Cancel</button>
            <button
              className={
                IsEditAllowed ? "btn btn-validate px-10 h-100" : " btn btn-validate px-10 h-100 disabled"
              }
              onClick={(e) => { onsubmitSaveDocument(e); handleNotes(e); }}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={modalActive}
        onHide={() => setModalActive(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="app-modal modal-md hk-login-v1"
      >
        <Modal.Body>
          <div className="download-header">
            <div className="hide-me"></div>
            {/* <button className="btn download-btn">
              Download PDF
            </button> */}

            <button
              className="btn-icon-transparent"
              onClick={() => setModalActive(false)}
            >
              <i className="icon-Icon-metro-cross"></i>
            </button>
          </div>
          <div className="pdfView-box">
            {!isNull(txtFile) ? txtFile : ""}
            {!isNull(imgFile) ? <img src={imgFile} alt="Image" /> : ""}
          </div>
          {isLoading ? <Loader /> : null}

          {pdfFile && (
            <>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                <Viewer
                  fileUrl={pdfFile}
                  defaultScale={1}
                  plugins={[defaultLayoutPluginInstance]}
                />
              </Worker>
            </>
          )}
        </Modal.Body>
        <div className="btns-group text-end px-3 py-3 br-top-1 br-clr">
          <button
            className="btn btn-gray"
            onClick={() => setModalActive(false)}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddNewTask;
